module.exports = __webpack_public_path__ + "static/media/Application programming interface-cuate.a7a98612.svg";